export default __webpack_public_path__ + "static/media/CalenderBlue.83aec445.svg";